import React from 'react';
import _ from 'lodash';
import padding from 'assets/scss/custom/padding.module.scss';
import { MenuItem } from '@material-ui/core';
import MySmallSelect from './MySmallSelect';

const Ordinal = ({ ordinal, setOrdinal }) => {

  const handleUpdateOrdinal = value => {
    if (_.isNumber(parseInt(value))) {
      setOrdinal(value);
    }
  };

  return (
      <MySmallSelect
        value={ordinal}
        select={false}
        label="Global Ordinal"
        onChange={e => handleUpdateOrdinal(e.target.value)}
        className={padding.bottom_sm}
      >
      </MySmallSelect>
  );
};

export default Ordinal;
